import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';

@Component({
    selector: 'app-documents-add-multiple',
    templateUrl: './documents-add-multiple.component.html',
    styleUrls: ['./documents-add-multiple.component.scss'],
})
export class DocumentsAddMultipleComponent implements OnInit {
    form: UntypedFormGroup;
    systemsDropDown: Array<DropDownItem> = [];
    selectedSystem: string;

    constructor(
        private route: ActivatedRoute,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
        this.initDropdowns();
    }

    initDropdowns() {
        var [categoriesRes, subcategoriesRes, systemsRes, typesRes, departmentsRes, documentTemplates] =
            this.route.snapshot.parent.data.dropdownData;

        systemsRes.forEach((x) => {
            if (x.bunkaskraning) {
                this.systemsDropDown.push({
                    value: x.documentSystemId.toString(),
                    viewValue: x.title,
                });
            }
        });
        // Sets default value
        this.form.get('documentSystemId').setValue(this.systemsDropDown[0].value);
        this.selectedSystem = this.systemsDropDown[0].viewValue;
        this.form.get('documentSystemId').valueChanges.subscribe((val) => {
            let system = this.systemsDropDown.find((x) => x.value == val);
            this.selectedSystem = system.viewValue;
        });
    }

    initForm() {
        this.form = this.formBuilder.group({
            documentSystemId: new FormControl(null, [Validators.required]),
        });
    }
}
